module.exports = __webpack_public_path__ + "static/img/主图2-1.8c5973d3.png";